import React from 'react';
import Button from '@material-ui/core/Button';
import { Title } from 'react-admin';
import CheckIcon from '@material-ui/icons/Check';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { makeStyles } from '@material-ui/core/styles';
import QuizTimer from "./QuizTimer";
import { useState, useEffect } from 'react';
import * as apiClient from "../../../apiClient";
import CircularProgress from '@material-ui/core/CircularProgress';
import { ISubject, ITest, IQuestion, IQuestionOption, ITestResponse } from '../../../model/ISubject';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useParams,
    useHistory
} from "react-router-dom";
import moment from 'moment';

import { InsertEmoticonTwoTone } from '@material-ui/icons';

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: "column",
        height: "100vh",
        position: "relative",
    },
    main: {
        height: "100%",
        position: "relative",
    },
    testContainer: {
        padding: 10,
        flex: 1,
        border: "1px solid #eee",
        display: "flex",
        flexDirection: "column",
        position: "absolute",
        left: 0,
        top: 0,
        right: 0,
        bottom: 80,
    },
    timerContainer: {
        padding: 10,
        border: "1px solid #eee",
        alignContent: "center",
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        maxHeight: "100%",
        margin: "0px 15px",
    },
    testButtons: {
        display: "flex",
        justifyContent: "space-between",
        position: "absolute",
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: "#cccccc",
        padding: 15,
    },
    buttonContainer: {
        flex: 1,
        display: "flex",
        justifyContent: "space-between",
    },
    questionContainer: {
        flex: 1,
        overflow: "auto"
    },
    testQuestion: {
        padding: "20px 10px",
    },
    testAnswers: {
        display: "flex",
        flexDirection: "column",
    },
    questionOption: {
        display: "flex",
        border: "1px solid #ccc",
        margin: "10px 0px",
        padding: 10,
        cursor: "pointer",
        "&:hover, &:focus": {
            backgroundColor: "#eee",
        },
        position: "relative"
    },
    selectedQuestionOption: {
        display: "flex",
        backgroundColor: "#bbb",
        border: "1px solid #aaa",
        margin: "10px 0px",
        padding: 10,
        cursor: "pointer",
        "&:hover, &:focus": {
            backgroundColor: "#eee",
        },
        position: "relative"
    },
    optionNumber: {
        padding: "5px 10px",
        backgroundColor: "#ccc",
        border: "1px solid #aaa",
        marginRight: 10,
        display: "flex",
        justifyContent: "center",
        alignContent: "center",
        alignItems: "center",
    },
    optionText: {
        padding: 5,
        minWidth: 300
    },
    testname: {
        margin: 5,
        textAlign: "center",
    },
    checkicon: {
        position: "absolute",
        right: 10,
        top: 10,
        color: "#006400",
    },
    questionnum: {
        position: "absolute",
        right: 20,
        top: 20,

    },
    questionimage: { verticalAlign: "middle" },
    optionimage: { verticalAlign: "middle" },

});

const Quiz = (props) => {
    const [isLoading, setIsLoading] = useState(true);
    const [isAllowed, setIsAllowed] = useState(true);
    const [test, setTest] = useState<any>();
    const [questionIndexList, setQuestionIndexList] = useState<number[]>([]);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [currentQuestion, setCurrentQuestion] = useState<any>();
    const [selectedOption, setSelectedOption] = useState(-1);
    const [saving, setSaving] = useState(false);
    const [userId, setUserId] = useState(0);
    const [testResponse, setTestResponse] = useState<ITestResponse>();
    const [isSettingOption, setIsSettingOption] = useState(false);
    const [finalReviewList, setFinalReviewList] = useState<any[]>([]);
    const [isReview, setIsReview] = useState(false);
    const [sectionText, setSectionText] = useState("");
    const [scoringTypeText, setScoringTypeText] = useState("");
    const classes = useStyles({});
    //let { id } = props.record.id;

    let history = useHistory();
    const [isBlurred, setIsBlurred] = useState(false);






    const loadSection = (id: any) => {
        setSectionText("");
        let resource = "statuses?filter[where][id]=" + id
        apiClient.getData(resource).then(res => {
            if (res[0].statusGroup != "SEC00") {
                setSectionText(res[0].status);
            }


        }).catch(err => {
            //console.log(err);
        });
    }

    const scoringTypeDetails = (id: any) => {
        setScoringTypeText("");
        let resource = "ScoringTypeDetails/" + id
        apiClient.getData(resource).then(res => {

            setScoringTypeText(res[0].ScoringTypeInstructions);



        }).catch(err => {
            //console.log(err);
        });
    }


    const getTestDetailsById = (id: any) => {
        apiClient.candidatetestdetails(id)
            .then(res => {
                debugger;
                let test: any = JSON.parse(res[0].Data);

                // Creating an array of question indexes
                let tempArr = test.testquestions.map((_, index) => index);

                // Uncomment if needed:
                // tempArr = apiClient.shuffle(tempArr);
                // tempArr = tempArr.slice(0, 10);

                setQuestionIndexList(tempArr);

                test.testquestions.forEach((question: any) => {
                    if (question.testquestionoptions) {
                        question.testquestionoptions?.forEach((option: any) => {
                            if (option?.userRatings) {
                                try {
                                    option.userRatings = JSON.parse(option?.userRatings);
                                } catch (error) {
                                    console.error("Error parsing userRatings:", error);
                                    option.userRatings = [];
                                }
                            } else {
                                option.userRatings = [];
                            }


                            if (option?.ratingAnswers) {
                                try {
                                    option.ratingAnswers = JSON.parse(option?.ratingAnswers);
                                } catch (error) {
                                    console.error("Error parsing userRatings:", error);
                                    option.ratingAnswers = [];
                                }
                            } else {
                                option.ratingAnswers = [];
                            }
                        });
                    }
                });

                // Updating state with the modified object
                setCurrentQuestion(test.testquestions[tempArr[0]]);
                setCurrentQuestionIndex(0);
                setTest(test);
                setIsLoading(false);
            })
            .catch(err => {
                console.error("API Error:", err);
            });
    };


    const previousQuestion = () => {
        if (currentQuestionIndex > 0) {
            let qindex = questionIndexList[currentQuestionIndex - 1];
            setCurrentQuestion(test?.testquestions[qindex]);
            setCurrentQuestionIndex(currentQuestionIndex - 1);
            setSelectedOption(-1);
            setIsReview(false);
        }

    }
    const nextQuestion = () => {
        if (currentQuestionIndex < (questionIndexList.length - 1)) {
            let qindex = questionIndexList[currentQuestionIndex + 1];
            setCurrentQuestion(test?.testquestions[qindex]);
            setCurrentQuestionIndex(currentQuestionIndex + 1);
            setSelectedOption(-1);
            //console.log("currentQuestionIndex = " + currentQuestionIndex);
            //console.log("Current Question : ");
            //console.log(currentQuestion);
        }
    }
    const prepareForReview = () => {
        let finalQuestions: any[] = [];
        questionIndexList.forEach((item, index) => {
            //console.log(item);
            let tq: any = test?.testquestions[item]!;
            let selOption = tq.testquestionoptions[0];
            let optionid = -1;
            if (tq.selectedOptionIndex != undefined) {
                selOption = tq.testquestionoptions[tq.selectedOptionIndex];
                optionid = selOption.id;
                tq.selectedOption = selOption;
            }
            finalQuestions.push(tq);
        });
        setFinalReviewList(finalQuestions);
        setIsReview(true);
    }
    const finishTest = () => {
        
        setSaving(true);
        let uId = localStorage.getItem("userId");
        let payload = { ...test, userId: uId }
        let isValid = true;
        let errorMsg = "";         
        test.testquestions.forEach((item: any) => {
            item.testquestionoptions.forEach((optionitem: any) => {
                if ((optionitem.EvaluatorRemarks == null || optionitem.EvaluatorRemarks.trim() == "")) {
                    isValid = false;
                    errorMsg = "Please enter text";
                    return; 
                }
                
                if ((optionitem.SecuredMarks == null || optionitem.SecuredMarks.length == 0)) {
                    isValid = false;
                    errorMsg = "Please enter marks";
                    return; 
                }
            });
        });
        if (!isValid) {
            alert(errorMsg);
            return;
        }
        apiClient.UpdateAssesmentTestResponsesDetails(payload).then(res => {

            if (res[0].ID > 0) {
                alert(res[0].ResultMsg);
                props.onCancel();
                // localStorage.setItem("testresult", res[0].ID.toString());
                // history.push("/quizresult");
            }
            else {
                alert(res[0].ResultMsg)
            }
            setSaving(false);
        }).catch(err => {
            setSaving(false);
            console.log(err);
        });
    }
    const toggleRating = (index: any, user: any, rating: any) => {
        setIsSettingOption(true);
        let cq: IQuestion = currentQuestion!;
        cq.selectedOptionIndex = index;
        setCurrentQuestion(cq);
        //console.log("Current Question : ");
        //console.log(cq);
        let m = moment();
        let qindex = questionIndexList[currentQuestionIndex];
        let questions = [...test?.testquestions!];
        questions[qindex].createddate = m.toISOString();

        let userRatings: any = questions[qindex].testquestionoptions[index].userRatings;
        if (!Array.isArray(userRatings)) {
            userRatings = []; // Initialize if it's undefined or null
        }

        if (userRatings.includes(rating)) {

            userRatings = userRatings.filter((currentRating: any) => currentRating !== rating);
        } else {
            // Add the value
            userRatings = [...userRatings, rating];
        }
        questions[qindex].testquestionoptions[index].userRatings = userRatings;

        questions[qindex].selectedOptionIndex = index;
        // if (test) {
        //     test.testquestions = questions;
        //     setTest(test);
        // }
        setTest({ ...test, testquestions: questions });
        setSelectedOption(index);


    };
    const handleRatingInput = (e: any, index: number) => {
        debugger
        setIsSettingOption(true);
        let cq: IQuestion = currentQuestion!;
        cq.selectedOptionIndex = index;
        setCurrentQuestion(cq);
        let m = moment().utcOffset(330).toISOString();
        let qindex = questionIndexList[currentQuestionIndex];
        let questions: any = [...test?.testquestions!];
        questions[qindex].createddate = m;
        questions[qindex].testquestionoptions[index].SecuredMarks = e.target.value;
        questions[qindex].selectedOptionIndex = index;
        // if (test) {
        //     test.testquestions = questions;
        //     setTest(test);
        // }
        setTest({ ...test, testquestions: questions });
        setSelectedOption(index);
    }


    const handleOpentextInput = (e: any, index: number) => {
        debugger
        setIsSettingOption(true);
        let cq: IQuestion = currentQuestion!;
        cq.selectedOptionIndex = index;
        setCurrentQuestion(cq);
        let m = moment().utcOffset(330).toISOString();
        let qindex = questionIndexList[currentQuestionIndex];
        let questions: any = [...test?.testquestions!];
        questions[qindex].createddate = m;
        questions[qindex].testquestionoptions[index].EvaluatorRemarks = e.target.value;
        questions[qindex].selectedOptionIndex = index;
        // if (test) {
        //     test.testquestions = questions;
        //     setTest(test);
        // }
        setTest({ ...test, testquestions: questions });
        setSelectedOption(index);
    }

    const setQuestionSelectedOption = (index: number) => {

        setIsSettingOption(true);
        let cq: IQuestion = currentQuestion!;
        cq.selectedOptionIndex = index;
        setCurrentQuestion(cq);
        let m = moment();
        let qindex = questionIndexList[currentQuestionIndex];
        let questions = [...test?.testquestions!];
        questions[qindex].createddate = m.toISOString();

        questions[qindex].selectedOptionIndex = index;
        if (test) {
            setTest({
                ...test,
                testquestions: [...questions],
            });
        }


        setSelectedOption(index);
    }
    const getOptionClass = (index: number) => {
        if (currentQuestion?.selectedOptionIndex == index) {
            return classes.selectedQuestionOption;
        }
        return classes.questionOption;
    }
    useEffect(() => {
        if (currentQuestion) {
            loadSection(currentQuestion?.sectionTypeId)
            scoringTypeDetails(currentQuestion?.scoringTypeId)
        }
    }, [currentQuestion]);

    useEffect(() => {

        getTestDetailsById(props.record.id);

    }, []);
    useEffect(() => {
        const disablePaste = (e: any) => {
            if (e.ctrlKey && e.key === "v") {
                e.preventDefault();
                alert("Pasting is disabled!");
            }
        };

        document.addEventListener("keydown", disablePaste);
        return () => {
            document.removeEventListener("keydown", disablePaste);
        };
    }, []);
    return (
        <div
            style={{

                transition: "filter 0.3s ease-in-out",
                padding: "20px",
                paddingBottom: "40px",

            }}
        >
            <div className={classes.root}>
                {isLoading && <div className="full-screen-loading">
                    <CircularProgress color="secondary" />
                    <div>Fetching Test details</div></div>}
                {!isAllowed && <div className="test-not-allowed">
                    <div className="not-allowed-message">
                        Either test not found or You have taken this test already. Please try again after 15 days.<br />Thanks! Trivium Education
                    </div>
                </div>}
                {!isReview && isAllowed && <div className={classes.main}>
                    <div className={classes.testContainer}>
                        {test && <h3 className={classes.testname}>{test.title}</h3>}
                        {questionIndexList && <div className={classes.questionnum}>{currentQuestionIndex + 1} of {questionIndexList.length}</div>}
                        <div className={classes.questionContainer}>
                            <div><h2>{sectionText}</h2></div>
                            {currentQuestion && <div className={classes.testQuestion}>
                                ({currentQuestionIndex + 1})
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: currentQuestion.instructions
                                    }}></div>

                                {currentQuestion.instructionUrl && <img className={classes.questionimage} src={currentQuestion.instructionUrl} />}
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: currentQuestion.question
                                    }}></div>


                                {currentQuestion.logourl && <img className={classes.questionimage} src={currentQuestion.logourl} />}
                            </div>}
                            {currentQuestion && <div className={classes.testQuestion}>
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: scoringTypeText
                                    }}></div>

                            </div>}

                            <div className={classes.testAnswers}>

                                {currentQuestion && currentQuestion.testquestionoptions && currentQuestion.testquestionoptions.map((item: any, index) => {
                                    return (
                                        <>
                                            <div key={index}

                                                onClick={() => { setQuestionSelectedOption(index); }}
                                                className={getOptionClass(index)}>
                                                <div className={classes.optionNumber}>{item.optiontitle}</div>

                                                <div className={classes.optionText}
                                                    dangerouslySetInnerHTML={{
                                                        __html: item.optiontext
                                                    }}
                                                >

                                                </div>

                                                {item.optionimage && <img className={classes.optionimage} src={item.optionimage!} />}
                                                {/* {selectedOption == index && <div className={classes.checkicon}><CheckCircleIcon fontSize="large" /></div>}
{currentQuestion.selectedOptionIndex == index && <div className={classes.checkicon}><CheckCircleIcon fontSize="large" /></div>} */}
                                            </div>
                                            <div style={{ display: "flex", flexDirection: "row", border: "1px solid lightgrey", }}>
                                                <div style={{ width: "50%", padding: "1%" }}>
                                                    <h4>Candidate Input</h4>
                                                    <textarea placeholder='Enter Here' key={item.id} rows={10} required style={{ width: "99%" }}
                                                        value={item.openTextInput ?? ""}
                                                        disabled
                                                        onChange={(e) => { handleOpentextInput(e, index); }}
                                                    />
                                                    {scoringTypeText && scoringTypeText.length > 0 && <div style={{ padding: "20px", display: "flex", justifyContent: "flex-end" }}>

                                                        <div style={{ marginBottom: "15px" }}>

                                                            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                                                <span style={{ fontWeight: "bold", fontSize: "14px", color: "#333" }}>
                                                                    Candidate Rating
                                                                </span>
                                                                {[1, 2, 3, 4, 5, 6].map((num) => (
                                                                    <div
                                                                        key={num}
                                                                        // onClick={() => toggleRating(index, null, num)}
                                                                        style={{
                                                                            padding: "10px 15px",
                                                                            border: "2px solid #000",
                                                                            backgroundColor: (item.userRatings || []).includes(num) ? "#4CAF50" : "#f0f0f0",
                                                                            color: (item.userRatings || []).includes(num) ? "#fff" : "#000",
                                                                            cursor: "pointer",
                                                                            borderRadius: "5px",
                                                                            textAlign: "center",
                                                                            minWidth: "40px",
                                                                            fontWeight: "bold",
                                                                            transition: "all 0.3s",
                                                                        }}
                                                                    >
                                                                        {num}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>

                                                    </div>}
                                                </div>
                                                <div style={{ width: "50%", padding: "1%" }}>
                                                    <h4>Evaluator Input</h4>
                                                    <textarea  placeholder='Enter Here' key={item.id} rows={10} required style={{ width: "99%" }}
                                                        value={item.EvaluatorRemarks ?? ""}

                                                        onChange={(e) => { handleOpentextInput(e, index); }}
                                                    />
                                                    {scoringTypeText && scoringTypeText.length > 0? (
                                                        <div
                                                            style={{
                                                                padding: "20px",
                                                                display: "flex",
                                                                justifyContent: "flex-end",
                                                                alignItems: "center",
                                                            }}
                                                        >
                                                            <div style={{ marginBottom: "15px", display: "flex", gap: "10px", alignItems: "center" }}>
                                                                <span style={{ fontWeight: "bold", fontSize: "14px", color: "#333" }}>
                                                                    Correct Rating
                                                                </span>
                                                                {item.ratingAnswers.map((num) => (
                                                                    <div
                                                                        key={num}
                                                                        // onClick={() => toggleRating(index, null, num)}
                                                                        style={{
                                                                            padding: "10px 15px",
                                                                            border: "2px solid #000",
                                                                            backgroundColor: "#4CAF50",
                                                                            color: "#fff",
                                                                            cursor: "pointer",
                                                                            borderRadius: "5px",
                                                                            textAlign: "center",
                                                                            minWidth: "40px",
                                                                            fontWeight: "bold",
                                                                            transition: "all 0.3s",
                                                                        }}
                                                                    >
                                                                        {num}
                                                                    </div>
                                                                ))}
                                                                <input
                                                                    type="number"
                                                                    style={{
                                                                        padding: "8px",
                                                                        borderRadius: "4px",
                                                                        border: "1px solid #ccc",
                                                                        fontSize: "14px",
                                                                        width: "100px",
                                                                        textAlign: "center",
                                                                    }}
                                                                    value={item.SecuredMarks}
                                                                    onChange={(e) => { handleRatingInput(e, index); }}
                                                                />
                                                            </div>
                                                        </div>
                                                    ):
                                                    <div
                                                    style={{
                                                        padding: "20px",
                                                        display: "flex",
                                                        justifyContent: "flex-end",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <div style={{ marginBottom: "15px", display: "flex", gap: "10px", alignItems: "center" }}> 
                                                        <input
                                                            type="number"
                                                            style={{
                                                                padding: "8px",
                                                                borderRadius: "4px",
                                                                border: "1px solid #ccc",
                                                                fontSize: "14px",
                                                                width: "100px",
                                                                textAlign: "center",
                                                            }}
                                                            value={item.SecuredMarks}
                                                            onChange={(e) => { handleRatingInput(e, index); }}
                                                        />
                                                    </div>
                                                </div>
                                                }

                                                </div>
                                            </div>
                                        </>
                                    )
                                })
                                }
                            </div>
                        </div>
                    </div>
                </div>}
                {isReview && currentQuestionIndex >= 9 && <div className="test-review-container">
                    <div className="review-caption">Please review the questions and selected answere before submitting the quiz.</div>
                    <div className="test-question-row">
                        <div className="test-question">
                            <div className="caption">Question</div>
                        </div>
                        <div className="question-option-selected" >
                            <div className="caption">Your Answer</div>
                        </div>
                    </div>
                    {finalReviewList && finalReviewList.map((item, index) => {
                        return (
                            <div key={index} className="test-question-row">

                                <div className="test-question">
                                    <div className="question-number">({index + 1})</div>
                                    <div className="question-text"
                                        dangerouslySetInnerHTML={{
                                            __html: item.question
                                        }}>
                                    </div>
                                    {item.logourl && <img className="question-image" src={item.logourl} />}
                                </div>
                                {item.selectedOption && <div className="question-option-selected" >
                                    <div className="option-number">{item.selectedOption.optiontitle}</div>
                                    <div className="option-text" dangerouslySetInnerHTML={{
                                        __html: item.selectedOption.optiontext
                                    }}>
                                    </div>
                                    {item.selectedOption.optionimage && <img className="option-image" src={item.selectedOption.optionimage!} />}
                                </div>}
                                {!item.selectedOption && <div className="question-option-selected" >
                                    <div className="caption">Not answered</div>
                                </div>}
                            </div>
                        )
                    })}
                </div>
                }
                {isAllowed && <div className={classes.testButtons}>
                    <div className={classes.buttonContainer}>
                        <div>
                            {currentQuestionIndex > 0 && <Button variant="contained" color="primary" onClick={() => { previousQuestion(); }}>
                                Previous Question
                            </Button>}
                        </div>
                        <div>
                            {/* {currentQuestionIndex >= 9 && !isReview && <Button variant="contained" color="primary" onClick={() => { prepareForReview(); }}>
                            Review Test
                        </Button>} */}

                            {currentQuestionIndex == questionIndexList.length - 1 && <Button variant="contained" color="primary" onClick={() => { finishTest(); }}>
                                Finish Test
                            </Button>}

                        </div>
                        <div>
                            {currentQuestionIndex < questionIndexList.length - 1 && <Button variant="contained" color="primary" onClick={() => { nextQuestion(); }}>
                                Next Question
                            </Button>}
                        </div>
                    </div>
                    {/* <div className={classes.timerContainer}>
                    {test && <QuizTimer onTimerComplete={finishTest} duration={test?.testduration} />}
                </div> */}
                </div>}
            </div>
        </div>
    );
};

export default Quiz;
